import * as css from 'css/exports.module.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { TagDescriptionInput } from './TagDescriptionInput';
import { TagNameInput } from './TagNameInput';
import { TagOwnersInput } from './TagOwnersInput';
import { useAction } from '@hooks';
import { When } from 'react-if';

import { Button, Col, Divider, Form, Row } from 'antd';
import { coreActions, SonarTag } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo, useState } from 'react';

export interface EditTagProps {
	tag: SonarTag;
}

interface FormValues {
	description: string;
	name: string;
	ownerIds: string[];
}

export const EditTag: React.FC<EditTagProps> = ({ tag }) => {
	const [ hexColor, setHexColor ] = useState(tag.hexColor);
	const requestDelete = useAction(coreActions.requestDeleteCoreTagsById);
	const requestPut = useAction(coreActions.requestPutCoreTagsById);

	const initialFormValues = useMemo(() => {
		const { description, ownerIds, name } = tag;

		return {
			description: description ?? '',
			hexColor,
			name,
			ownerIds: ownerIds.map((id) => String(id))
		};
	}, [ hexColor, tag ]);

	const handleDelete = useCallback(() => {
		requestDelete({
			id: tag.id
		});
	}, [ tag.id, requestDelete ]);

	const handleSubmit = useCallback(
		(values: FormValues) => {
			requestPut({
				...values,
				hexColor,
				id: tag.id,
				ownerIds: values.ownerIds.map((id) => Number(id))
			});
		},
		[ hexColor, tag.id, requestPut ]
	);

	return (
		<div
			className='tag'
			key={ tag.id }>
			<Form
				className='edit'
				initialValues={ initialFormValues }
				name={ String(tag.id) }
				onFinish={ handleSubmit }>
				<Row gutter={ [ Number(css.size16), 0 ] }>
					<Col span={ 6 }>
						<TagNameInput
							disabled={ tag.autoTagged }
							getPopupContainer={ getDirectParent }
							hexColor={ hexColor }
							name='name'
							onColorClick={ setHexColor } />
					</Col>

					<Col span={ 18 }>
						<TagOwnersInput
							disabled={ tag.autoTagged }
							name='ownerIds' />
					</Col>
				</Row>

				<TagDescriptionInput
					disabled={ tag.autoTagged }
					name='description' />

				<When condition={ !tag.autoTagged }>
					<Row justify='space-between'>
						<Button
							className='tag-save-button'
							htmlType='submit'
							type='primary'>
							{ COPY_SPECIFIC.SAVE }
						</Button>
						<Button
							className='tag-delete-button'
							danger
							onClick={ handleDelete }>
							{ COPY_SPECIFIC.DELETE }
						</Button>
					</Row>
				</When>
			</Form>
			<Divider />
		</div>
	);
};
